/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { Command, PopupEditing, errorAlert } from '../../Shared';
import { getRowId, updateDocNumbers, userroles } from '../../common';
import {
  getHritems,
  getProducts,
  createHritem,
  updateHritem,
  deleteHritem,
} from '../../graphql';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  currencyFormatterEmpty,
  timeFormatter,
  userFormatter,
} from '../../Shared/colorFormat';
import { AlertLocal, SearchTable } from '../../components';
import { getColumns } from '../../common/columns';
import { Box, Typography } from '@material-ui/core';
import useEmployees from '../../hooks/useEmployees';
import { useTemplate, useUsers } from '../../hooks';
import { getTasks } from '../../graphql/query';
import AutoFieldLocal from '../../components/fields/AutoFieldLocal';
import { TableComponent } from '../components/TableComponent';
import HRContext from '../../contexts/hr';
import PopupOvertime from '../../pubups/PopupOvertime';
import { errorDeleteAlert } from '../common/funcs';

const Hritems = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end, theme, company } = props;
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });

  const col = getColumns({ isRTL, words });
  const { tempoptions } = useTemplate();

  const [columns] = useState(
    [
      { name: 'time', title: words?.time },
      { name: 'opDocNo', title: words?.ref },
      col.employee,
      col.contract,
      { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
      { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
      { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
      { name: 'desc', title: words?.notes },
      col.userId,
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 100 },
    { columnName: 'opDocNo', width: 120 },
    { columnName: col.employee.name, width: 200 },
    { columnName: col.contract.name, width: 200 },
    { columnName: 'overtime', width: 120 },
    { columnName: 'bonos', width: 120 },
    { columnName: 'deduction', width: 120 },
    { columnName: 'desc', width: 200 },
    { columnName: 'userId', width: 150 },
  ]);

  const [rows, setRows] = useState([]);
  const [emplvalue, setEmplvalue] = useState<any>(null);

  const { activeemployees: employees } = useEmployees();
  const { users } = useUsers();

  const {
    state: { hiddenColumnNames },
    dispatch,
  } = useContext(HRContext);

  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };

  const [loadHritems, opData]: any = useLazyQuery(getHritems, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: getHritems,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
          employeeId: emplvalue ? emplvalue?._id : undefined,
        },
      },
      { query: getProducts },
      { query: getTasks },
    ],
  };

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
      employeeId: emplvalue ? emplvalue?._id : undefined,
    };
    if (start && end) {
      loadHritems({
        variables,
      });
    }
  }, [start, end, emplvalue]);

  const [addHritem] = useMutation(createHritem, refresQuery);
  const [editHritem] = useMutation(updateHritem, refresQuery);
  const [removeHritem] = useMutation(deleteHritem, refresQuery);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const _id = deleted[0];
      const res = await removeHritem({ variables: { _id } });
      if (res?.data?.deleteHritem?.ok === false) {
        if (res?.data?.deleteHritem?.error.includes('related')) {
          await errorDeleteAlert(setAlrt, isRTL);
        } else {
          await errorAlert(setAlrt, isRTL);
        }
      } else {
        setRows(rows.filter((row: any) => row._id !== _id));
      }
    }
  };
  useEffect(() => {
    if (opData?.data?.getHritems?.data) {
      const { data } = opData.data.getHritems;
      const rdata = updateDocNumbers(data);
      setRows(rdata);
    }
  }, [opData]);

  return (
    <>
      <Box
        display="flex"
        style={{
          position: 'absolute',
          top: 55,
          left: isRTL ? 330 : undefined,
          right: isRTL ? undefined : 350,
          display: 'flex',
          flexGrow: 1,
          zIndex: 111,
        }}
      >
        <Box display={'flex'}>
          <AutoFieldLocal
            name="employee"
            title={words?.employee}
            words={words}
            options={employees}
            value={emplvalue}
            setSelectValue={setEmplvalue}
            isRTL={isRTL}
            width={300}
            mb={0}
          ></AutoFieldLocal>
        </Box>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <EditingState onCommitChanges={commitChanges} />
        <SearchState />
        <PagingState defaultCurrentPage={0} defaultPageSize={10} />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 60 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            'time',
            'opDocNo',
            col.employee.name,
            col.contract.name,
            'overtime',
            'bonos',
            'deduction',
            'desc',
            'userId',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['userId']}
          formatterComponent={(props: any) =>
            userFormatter({ ...props, users })
          }
        ></DataTypeProvider>
        <DataTypeProvider
          for={['overtime', 'bonos', 'deduction']}
          formatterComponent={currencyFormatterEmpty}
        ></DataTypeProvider>
        <TableEditColumn
          showEditCommand={userroles?.sales?.edit}
          showDeleteCommand={!userroles?.isEmployee && userroles?.sales?.delete}
          showAddCommand={userroles?.sales?.add}
          commandComponent={Command}
        ></TableEditColumn>

        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
          }
        />

        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <PopupEditing addAction={addHritem} editAction={editHritem}>
          <PopupOvertime
            words={words}
            company={company}
            theme={theme}
            isRTL={isRTL}
          ></PopupOvertime>
        </PopupEditing>
      </Grid>
      {alrt.show && (
        <AlertLocal
          isRTL={isRTL}
          type={alrt?.type}
          msg={alrt?.msg}
          top
        ></AlertLocal>
      )}
    </>
  );
});

export default Hritems;
